import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TelegramChannelAssignmentList from '../components/TelegramChannelAssignmentList';
import TelegramChannelAssignmentForm from '../components/TelegramChannelAssignmentForm';

const TelegramChannelAssignmentsPage = () => {
    return (
        <div>
            <Routes>
                <Route path="/" element={<TelegramChannelAssignmentList />} />
                <Route path="new" element={<TelegramChannelAssignmentForm />} />
                <Route path="edit/:id" element={<TelegramChannelAssignmentForm />} />
            </Routes>
        </div>
    );
};

export default TelegramChannelAssignmentsPage;